import { backButtonFunctionality } from "./modules/go-back-button";
import { highlightSearchTerms } from './modules/highlight-search';
import { selectField } from "./modules/form-select-field";
import { mainMenu } from "./modules/main-menu";
import { sliiderWrapper } from "./modules/slider-wrapper";
import { paginationScrollTo } from "./modules/padintion-scroll-to";

document.addEventListener( 'DOMContentLoaded', function() {
    mainMenu();
    backButtonFunctionality();
    highlightSearchTerms();
    selectField();
    sliiderWrapper();
    paginationScrollTo();
  }
);


 